import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { feedbackcard } from '@yes.technology/react-toolkit'
import { useSectionGroupActions } from '../Section/SectionContext'
import { useIsOpen } from 'shared/hooks'

export const useGroupRemoveModal = () => {
  const { t } = useTranslation()
  const { isOpen, open, close } = useIsOpen()
  const { handleRemoveCurrentGroup } = useSectionGroupActions()

  const onModalSuccess = useCallback(() => {
    close()
    handleRemoveCurrentGroup()
    feedbackcard(t('filter-fields.group-remotion.title'), {
      message: t('filter-fields.group-remotion.message'),
      type: 'success'
    })
  }, [close, handleRemoveCurrentGroup, t])

  return { isOpen, open, close, onModalSuccess }
}
